import {Container} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {DispatchReportPage} from '../../../dispatch-report/dispatch-report-page'
import {validateDispatchReportSearch} from '../../../dispatch-report/search'

export const Route = createFileRoute('/_app/dispatch/report')({
    validateSearch: validateDispatchReportSearch,
    component: DispatchReportRoute,
})

function DispatchReportRoute() {
    const search = Route.useSearch()

    return (
        <Container fluid py="xl">
            <DispatchReportPage search={search} />
        </Container>
    )
}
